export default __webpack_public_path__ + "static/media/illustration.8299a735.png";